import {API} from '@/API/API';
import {useApiLoader} from '@/Hooks';

const useCreateOrderByPreOrders = (campaignID: number, callBack: Function) => {
  return useApiLoader(async () => {
    return await API.Campaigns.preOrdersToOrders(campaignID).then(async () => await callBack());
  }, [campaignID]);
};
export default useCreateOrderByPreOrders;
